module.exports = __webpack_public_path__ + "static/media/bg_minecraft.dee75189.jpg";